import { CButton, CCol, CContainer, CFormLabel, CFormTextarea, CModal, CNav, CNavItem, CNavLink, CTabContent, CFormCheck, CTabPane, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow, CTooltip } from '@coreui/react'
import React, { useEffect, useMemo, useState } from 'react'
import Graytextarea from '../Graytextarea'
import { Info, Plus } from 'lucide-react'
import SaveExtra from '../../services/general/saveExtraData.api'
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import FetchOrderForAssessment from '../../views/dashboard/fetchOrderForAssessment'
import Editor, { Toolbar } from 'react-simple-wysiwyg'
import BulletTextArea from '../BulletTextArea'
import { buildHeaderPlanSelection, buildStatementPlanSelection, collectSelectedAssessmentOrderData, getSuggestionKey, getSuggestionText, getTitleKey, renderAssessmentSuggestionHtml, restoreAssessmentPlanSelections } from '../../utils/assessmentPlanSuggestions'

const getAccordionTitleLabel = (accordion) => {
  const title = accordion?.title?.trim() || ''
  const code = (accordion?.titleCode || accordion?.code || accordion?.Code || accordion?.icdCode || accordion?.ICDCode || accordion?.icd)?.toString().trim()

  if (!title) return code || ''
  if (!code || title.includes(`[${code}]`) || title.endsWith(code)) return title

  return `${title} [${code}]`
}

const questionFields = [
  { key: 'rollLeftAndRight', label: 'Roll left and right' },
  { key: 'sitToLying', label: 'Sit to lying' },
  { key: 'lyingToSittingOnSideOfBed', label: 'Lying to sitting on side of bed' },
  { key: 'sitToStand', label: 'Sit to stand' },
  { key: 'chairToBedTransfer', label: 'Chair to bed transfer' },
  { key: 'toiletTransfer', label: 'Toilet transfer' },
  { key: 'walk10Feet', label: 'Walk 10 feet' },
  { key: 'ambulatoryAids', label: 'Ambulatory aids' },
]

const FallsAssessment = ({ noteStructureRef, diagnosisName, isAllotedToProvider, saveTreatsShell, noteID, noteRefTrigger, showDataIfNoteIsFollowUp = true, patientID, showTreatmentAsAccordion, setAddedChangesToAssessment }) => {
  const [assessmentSuggestions, setAssessmentSuggestions] = useState('')
  const [mobilityData, setMobilityData] = useState(null)
  const [total, setTotal] = useState([])
  const [morseScoreDate, setMorseScoreDate] = useState('')
  const [labsImaging, setLabsImaging] = useState('')
  const [poa, setPoa] = useState('')
  const [freeType, setFreeType] = useState('')
  const [visible, setVisible] = useState(false)
  const [orderModalVisible, setOrderModalVisible] = useState(false)
  const [activeKey, setActiveKey] = useState(1)
  const [activeKey2, setActiveKey2] = useState(1)
  const [assessmentFinalValue, setAssessmentFinalValue] = useState('')

  const [sugesstionsAssessmentsList, setSugesstionsAssessmentsList] = useState([]) //putting the fetched data
  const [selectedAssessmentSuggestionStrings, setSelectedAssessmentSuggestionString] = useState([])
  const [selectedPlanSuggestion, setSelectedPlanSuggestion] = useState([])
  const [showItemsDescriptions, setShowItemsDescriptions] = useState([])
  const [formattedSelectedPlanSuggestionsStrings, setFormattedSelectedPlanSuggestionsStrings] = useState([])
  const [selectedIds, setSelectedId] = useState([])
  const [selectedOrder, setSelectedOrder] = useState([])

  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')

  useEffect(() => {
    const assessment = noteStructureRef.current?.assessment?.[diagnosisName]
    if (!assessment) return

    const { MobilityAssessment, POA, LabImaging, FreeType, MorseScore, assessmentSuggestions } = assessment

    if (MobilityAssessment?.assessment) {
      setMobilityData(MobilityAssessment.assessment)
    }

    if (assessmentSuggestions) {
      setAssessmentSuggestions(assessmentSuggestions)
      setAssessmentFinalValue(assessmentSuggestions)
    }

    if (POA) {
      setPoa(POA)
    }

    if (LabImaging) {
      setLabsImaging(LabImaging)
    }

    if (FreeType) {
      setFreeType(FreeType)
      setTempFreeType(FreeType)
    }

    if (MorseScore) {
      setMorseScoreDate(MorseScore.date || '')
      if (MorseScore.score) {
        setTotal(MorseScore.score[6] || 0)
      }
    }
  }, [noteRefTrigger, diagnosisName])

  const handleLabsChanges = (value) => {
    setLabsImaging(value)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          LabImaging: value,
        },
      },
    }
    ;``
  }

  // Freetype center
  const [tempFreeType, setTempFreeType] = useState('')
  const [visibleModalTempFreeType, setVisibleModalTempFreeType] = useState(false)
  // const handleFreeTypeChanges = async(value) => {
  //     setFreeType(value);
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 FreeType: value
  //             }
  //         }
  //     };
  //     // await saveTreatsShell(false)
  // }
  const handleSaveFreetype = async () => {
    setVisibleModalTempFreeType(false)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          FreeType: tempFreeType,
        },
      },
    }
    setFreeType(tempFreeType)
    await saveTreatsShell(false)
  }
  // Freetype center

  // useEffect(() => {
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 assessmentSuggestions: assessmentSuggestions,
  //             }
  //         }

  //     };
  // }, [assessmentSuggestions])

  const getAncestorTitleKeys = (targetKey, accordions, parentTitleKeys = []) => {
    for (const accordion of accordions || []) {
      const currentTitleKey = getTitleKey(accordion.id)
      const nextParentTitleKeys = [...parentTitleKeys, currentTitleKey]
      const suggestions = accordion?.suggestions?.suggestionName || []

      if (currentTitleKey === targetKey) return parentTitleKeys

      const hasMatchingSuggestion = suggestions.some((suggestion) => getSuggestionKey(accordion.id, suggestion) === targetKey)

      if (hasMatchingSuggestion) return nextParentTitleKeys

      if (accordion.children?.length) {
        const nestedAncestorKeys = getAncestorTitleKeys(targetKey, accordion.children, nextParentTitleKeys)
        if (nestedAncestorKeys.length > 0) return nestedAncestorKeys
      }
    }

    return []
  }

  const getHeaderPlanSelectionsForKeys = (titleKeys) => {
    const selectedTitleKeySet = new Set(titleKeys || [])
    const planSelections = []

    const visit = (accordions) => {
      for (const accordion of accordions || []) {
        const titleKey = getTitleKey(accordion.id)

        if (selectedTitleKeySet.has(titleKey)) {
          const headerPlan = buildHeaderPlanSelection(accordion, getAccordionTitleLabel(accordion))

          if (headerPlan) {
            planSelections.push(headerPlan)
          }
        }

        if (accordion.children?.length) {
          visit(accordion.children)
        }
      }
    }

    visit(sugesstionsAssessmentsList)

    return planSelections
  }

  const mergePlanSelections = (currentSelections, selectionsToAdd) => {
    const merged = [...currentSelections]

    selectionsToAdd.filter(Boolean).forEach((selection) => {
      if (!merged.some((item) => item.key === selection.key)) {
        merged.push(selection)
      }
    })

    return merged
  }

  const toggleAssessmentKey = (key, shouldSelect) => {
    const applySelectionUpdate = (prev) => {
      if (shouldSelect) {
        const nextKeys = prev.includes(key) ? [...prev] : [...prev, key]
        const ancestorTitleKeys = getAncestorTitleKeys(key, sugesstionsAssessmentsList)

        ancestorTitleKeys.forEach((ancestorKey) => {
          if (!nextKeys.includes(ancestorKey)) {
            nextKeys.push(ancestorKey)
          }
        })

        return nextKeys
      }

      return prev.filter((item) => item !== key)
    }

    setSelectedAssessmentSuggestionString(applySelectionUpdate)
    setSelectedId(applySelectionUpdate)
  }

  useEffect(() => {
    const selectedAssessmentIds = noteStructureRef?.current?.assessment?.[diagnosisName]?.formattedSelectedSuggestionIdString
    const storedKeys = typeof selectedAssessmentIds === 'string' ? selectedAssessmentIds.split('\n').filter(Boolean) : []

    if (storedKeys.length > 0) {
      const restored = restoreAssessmentPlanSelections(sugesstionsAssessmentsList, storedKeys, getAccordionTitleLabel)
      setSelectedAssessmentSuggestionString(restored.assessmentKeys)
      setSelectedPlanSuggestion(restored.planSources)
      setSelectedId(restored.assessmentKeys)
    } else {
      const assessmentSuggestionAdded = noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions
      const legacySelectionText = typeof assessmentSuggestionAdded === 'string' ? assessmentSuggestionAdded.split('\n').map((line) => line.trim().replace(/^[•\-*]+\s*/, '')).filter(Boolean) : []
      const legacyKeys = []

      const collectLegacyKeys = (accordions) => {
        for (const accordion of accordions || []) {
          accordion?.suggestions?.suggestionName?.forEach((suggestion) => {
            const suggestionText = getSuggestionText(suggestion)
            if (suggestionText && legacySelectionText.includes(suggestionText)) {
              legacyKeys.push(getSuggestionKey(accordion.id, suggestion))
            }
          })

          if (accordion.children?.length) {
            collectLegacyKeys(accordion.children)
          }
        }
      }

      collectLegacyKeys(sugesstionsAssessmentsList)
      const restored = restoreAssessmentPlanSelections(sugesstionsAssessmentsList, legacyKeys, getAccordionTitleLabel)
      setSelectedAssessmentSuggestionString(restored.assessmentKeys)
      setSelectedPlanSuggestion(restored.planSources)
      setSelectedId(restored.assessmentKeys)
      if (!legacyKeys.length) setAssessmentFinalValue(assessmentSuggestionAdded || '')
    }

    const formattedPlanSelections = noteStructureRef?.current?.plans?.[diagnosisName]?.formattedSelectedPlanSuggestionsStrings
    if (Array.isArray(formattedPlanSelections)) {
      setFormattedSelectedPlanSuggestionsStrings(formattedPlanSelections)
    } else {
      setFormattedSelectedPlanSuggestionsStrings([])
    }
  }, [diagnosisName, sugesstionsAssessmentsList])

  const getAllDiagnosisDifferential = async () => {
    let data = await SaveExtra('Get_By_Type', 'AssesmentSuggestions', '', '')
    data = JSON.parse(data.d)?.Data || []

    if (data) {
      data = data.map((item) => ({
        Id: item.Id,
        Data: JSON.parse(item?.JsonData),
      }))
    }

    const findAssessmentSuggestionForDiagnosis = data.find((item) => item?.Data?.diagnosis?.label?.trim()?.toLowerCase() === diagnosisName?.trim()?.toLowerCase())
    setSugesstionsAssessmentsList(findAssessmentSuggestionForDiagnosis?.Data?.accordions || [])
  }

  useEffect(() => {
    if (!diagnosisName) return
    getAllDiagnosisDifferential()
  }, [diagnosisName])

  const renderSuggestions = (accordion) => (
    <>
      {accordion.suggestions?.suggestionName?.map((item) => {
        const suggestionName = getSuggestionText(item)
        if (!suggestionName) return null
        const suggestionKey = getSuggestionKey(accordion.id, item)

        return (
          <div key={suggestionKey}>
            <div className="d-flex align-items-center gap-2">
              <CFormCheck
                checked={selectedAssessmentSuggestionStrings.includes(suggestionKey)}
                onChange={() => {
                  const isAlreadySelected = selectedAssessmentSuggestionStrings.includes(suggestionKey)

                  if (isAlreadySelected) {
                    toggleAssessmentKey(suggestionKey, false)
                    setSelectedPlanSuggestion((prev) => prev.filter((s) => s.key !== suggestionKey))
                  } else {
                    toggleAssessmentKey(suggestionKey, true)

                    const planSelection = buildStatementPlanSelection(accordion, item)
                    const ancestorPlanSelections = getHeaderPlanSelectionsForKeys(getAncestorTitleKeys(suggestionKey, sugesstionsAssessmentsList))

                    setSelectedPlanSuggestion((prev) => mergePlanSelections(prev, [planSelection, ...ancestorPlanSelections]))
                  }
                }}
                id={`suggestion-${suggestionKey}`}
                label={suggestionName}
              />

              {item?.description && (
                <span
                  className="d-inline-flex align-items-center"
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    setShowItemsDescriptions((prev) =>
                      prev.includes(`suggestion-${suggestionKey}`) ? prev.filter((id) => id !== `suggestion-${suggestionKey}`) : [...prev, `suggestion-${suggestionKey}`],
                    )
                  }
                >
                  <Info strokeWidth={1} size={16} />
                </span>
              )}
            </div>
            {showItemsDescriptions.includes(`suggestion-${suggestionKey}`) && <div style={{ color: 'orange', whiteSpace: 'pre-line', fontSize: '12px', padding: '8px 10px' }}>{item?.description}</div>}
          </div>
        )
      })}
    </>
  )

  useEffect(() => {
    setSelectedOrder(collectSelectedAssessmentOrderData(sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings))
  }, [sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings])

  const renderNestedAccordions = (accordions) => {
    return (
      <CAccordion className="assessment-suggestion-modal__accordion">
        {accordions.map((accordion, index) => {
            const hasTitle = accordion?.title && accordion.title.trim() !== ''
            const hasSuggestions = (accordion?.suggestions?.suggestionName || []).length > 0
            const hasChildren = (accordion?.children || []).length > 0
            const titleKey = getTitleKey(accordion.id)
            const isTitleSelected = selectedAssessmentSuggestionStrings.includes(titleKey)

            return (
              hasTitle ? (
                <CAccordionItem itemKey={accordion.id || index} key={accordion.id || index}>
                  <CAccordionHeader>
                    <div className="gap-2 d-flex align-items-center justify-content-between w-100">
                      <div className="d-flex align-items-center gap-2">
                        <CFormCheck
                          className="mb-0"
                          id={`title-${titleKey}`}
                          checked={isTitleSelected}
                          onMouseDown={(event) => event.stopPropagation()}
                          onClick={(event) => event.stopPropagation()}
                          onChange={(event) => {
                            const shouldSelect = event.target.checked
                            toggleAssessmentKey(titleKey, shouldSelect)
                            setSelectedPlanSuggestion((prev) => {
                              if (!shouldSelect) return prev.filter((item) => item.key !== titleKey)
                              const headerPlan = buildHeaderPlanSelection(accordion, getAccordionTitleLabel(accordion))
                              return mergePlanSelections(prev, [headerPlan])
                            })
                          }}
                        />
                        <span>{getAccordionTitleLabel(accordion)}</span>
                      </div>
                      {accordion?.description && (
                        <span
                          className="d-inline-flex align-items-center"
                          style={{ cursor: 'pointer' }}
                          onClick={(event) => {
                            event.stopPropagation()
                            const descriptionKey = `accordion-${accordion.id || index}`
                            setShowItemsDescriptions((prev) => (prev.includes(descriptionKey) ? prev.filter((id) => id !== descriptionKey) : [...prev, descriptionKey]))
                          }}
                        >
                          <Info strokeWidth={1} size={16} />
                        </span>
                      )}
                    </div>
                  </CAccordionHeader>
                  {showItemsDescriptions.includes(`accordion-${accordion.id || index}`) && <div style={{ color: 'orange', whiteSpace: 'pre-line', fontSize: '12px', padding: '8px 10px' }}>{accordion.description}</div>}
                  <CAccordionBody>
                    {hasSuggestions && renderSuggestions(accordion)}
                    {hasChildren && renderNestedAccordions(accordion.children)}
                  </CAccordionBody>
                </CAccordionItem>
              ) : (
                <div key={accordion.id || index}>
                  {hasSuggestions && renderSuggestions(accordion)}
                  {hasChildren && renderNestedAccordions(accordion.children)}
                </div>
              )
            )
          })}
      </CAccordion>
    )
  }

  const renderAccordions = () => {
    if (sugesstionsAssessmentsList?.length) {
      return renderNestedAccordions(sugesstionsAssessmentsList)
    }
    return null
  }

  const getFormattedTitleLine = (accordion, level, hasSelectedSubData = false) => {
    const titleLabel = getAccordionTitleLabel(accordion)

    if (!titleLabel) return ''
    if (level === 0 && hasSelectedSubData && !titleLabel.endsWith(':')) return `${titleLabel}:`

    return titleLabel
  }

  const getAssessmentBulletText = (accordions, selectedKeys, level = 0) => {
    const lines = []

    accordions?.forEach((accordion) => {
      const children = accordion.children || []
      const titleKey = getTitleKey(accordion.id)
      const isTitleSelected = selectedKeys.includes(titleKey)

      const hasSelectedSubData = (items) =>
        items.some((item) => {
          const hasSelectedSuggestion = item?.suggestions?.suggestionName?.some((suggestion) => selectedKeys.includes(getSuggestionKey(item.id, suggestion)))

          return hasSelectedSuggestion || hasSelectedSubData(item.children || [])
        })

      const hasSelectedDescendant = (items) =>
        items.some((item) => {
          const hasSelectedTitle = selectedKeys.includes(getTitleKey(item.id))
          const hasSelectedSuggestion = item?.suggestions?.suggestionName?.some((suggestion) => selectedKeys.includes(getSuggestionKey(item.id, suggestion)))

          return hasSelectedTitle || hasSelectedSuggestion || hasSelectedDescendant(item.children || [])
        })

      if (!isTitleSelected && !hasSelectedDescendant([accordion])) return

      lines.push(`${'  '.repeat(level)}${getFormattedTitleLine(accordion, level, hasSelectedSubData([accordion]))}`)

      accordion.suggestions?.suggestionName?.forEach((suggestion) => {
        const key = getSuggestionKey(accordion.id, suggestion)
        const suggestionText = getSuggestionText(suggestion)

        if (suggestionText && selectedKeys.includes(key)) {
          lines.push(`${'  '.repeat(level + 1)}• ${suggestionText}`)
        }
      })

      if (children.length) {
        lines.push(...getAssessmentBulletText(children, selectedKeys, level + 1))
      }
    })

    return lines
  }

  const normalizeAssessmentLine = (line) => String(line || '').trim().replace(/\s+/g, ' ').toLowerCase()

  const getAssessmentLineKey = (line) =>
    normalizeAssessmentLine(line).replace(/^(?:[•\-*]\s*)+/, '')

  const getAssessmentLines = (text) =>
    String(text || '')
      .replace(/\r\n/g, '\n')
      .split('\n')
      .map((line) => line.trimEnd())
      .filter((line) => line.trim())

  const getAllAssessmentSuggestionLineSet = (accordions) => {
    const lines = new Set()

    const addLine = (line) => {
      const normalizedLine = normalizeAssessmentLine(line)

      if (normalizedLine) lines.add(normalizedLine)
    }

    const visit = (items) => {
      for (const accordion of Array.isArray(items) ? items : []) {
        const titleLabel = getAccordionTitleLabel(accordion)

        if (titleLabel) {
          addLine(titleLabel)
          addLine(`${titleLabel}:`)
        }

        const suggestions = Array.isArray(accordion?.suggestions?.suggestionName)
          ? accordion.suggestions.suggestionName
          : []

        suggestions.forEach((suggestion) => {
          const suggestionText = getSuggestionText(suggestion)

          if (suggestionText) {
            addLine(suggestionText)
            addLine(`- ${suggestionText}`)
            addLine(`• ${suggestionText}`)
          }
        })

        visit(accordion?.children)
      }
    }

    visit(accordions)
    return lines
  }

  const mergeAssessmentSuggestionText = (selectedSuggestionText, currentText, accordions) => {
    const selectedLines = getAssessmentLines(selectedSuggestionText)
    const currentLines = getAssessmentLines(currentText)
    const knownSuggestionLines = getAllAssessmentSuggestionLineSet(accordions)
    const selectedLineIndexes = new Map()
    const existingSelectedLines = new Map()
    const manualLinesByAnchor = new Map()
    let lastSelectedLineIndex = -1
    let hasCurrentSuggestionLine = false

    selectedLines.forEach((line, index) => {
      const lineKey = getAssessmentLineKey(line)

      if (lineKey && !selectedLineIndexes.has(lineKey)) {
        selectedLineIndexes.set(lineKey, index)
      }
    })

    currentLines.forEach((line) => {
      const normalizedLine = normalizeAssessmentLine(line)
      const lineKey = getAssessmentLineKey(line)
      const selectedLineIndex = selectedLineIndexes.get(lineKey)
      const isSuggestionLine =
        knownSuggestionLines.has(normalizedLine) ||
        knownSuggestionLines.has(lineKey)

      if (isSuggestionLine) {
        hasCurrentSuggestionLine = true

        if (selectedLineIndex !== undefined) {
          if (!existingSelectedLines.has(selectedLineIndex)) {
            existingSelectedLines.set(selectedLineIndex, line)
          }
          lastSelectedLineIndex = selectedLineIndex
        }
        return
      }

      if (lineKey) {
        const anchoredLines = manualLinesByAnchor.get(lastSelectedLineIndex) || []
        anchoredLines.push(line)
        manualLinesByAnchor.set(lastSelectedLineIndex, anchoredLines)
      }
    })

    const mergedLines = []
    const seenLines = new Set()
    const addUniqueLine = (line) => {
      const normalizedLine = normalizeAssessmentLine(line)

      if (!normalizedLine || seenLines.has(normalizedLine)) return

      seenLines.add(normalizedLine)
      mergedLines.push(line)
    }

    if (hasCurrentSuggestionLine) {
      manualLinesByAnchor.get(-1)?.forEach(addUniqueLine)
    }

    selectedLines.forEach((line, index) => {
      addUniqueLine(existingSelectedLines.get(index) || line)
      manualLinesByAnchor.get(index)?.forEach(addUniqueLine)
    })

    if (!hasCurrentSuggestionLine) {
      manualLinesByAnchor.get(-1)?.forEach(addUniqueLine)
    }

    return mergedLines.join('\n')
  }

  useEffect(() => {
    const selectedSuggestionText = getAssessmentBulletText(
      sugesstionsAssessmentsList,
      selectedAssessmentSuggestionStrings
    ).join('\n')

    setAssessmentFinalValue((currentValue) =>
      mergeAssessmentSuggestionText(
        selectedSuggestionText,
        currentValue,
        sugesstionsAssessmentsList
      )
    )
  }, [selectedAssessmentSuggestionStrings, sugesstionsAssessmentsList, visible])

  const displayedAssessmentSuggestions = useMemo(() => {
    const storedSelectedIds = (noteStructureRef?.current?.assessment?.[diagnosisName]?.formattedSelectedSuggestionIdString || '')
      .split('\n')
      .map((item) => item.trim())
      .filter(Boolean)

    if (sugesstionsAssessmentsList?.length && storedSelectedIds.length > 0) {
      const bulletLines = getAssessmentBulletText(sugesstionsAssessmentsList, storedSelectedIds)

      if (bulletLines.length > 0) {
        return mergeAssessmentSuggestionText(
          bulletLines.join('\n'),
          assessmentSuggestions,
          sugesstionsAssessmentsList
        )
      }
    }

    return assessmentSuggestions
  }, [assessmentSuggestions, diagnosisName, noteStructureRef, sugesstionsAssessmentsList])

  const getPlanOptionKey = (source, suggestion, index) => {
    const optionId = suggestion?.id ?? suggestion?.ID ?? suggestion?.key ?? 'index'
    return `plan-option::${source.key}::${optionId}::${index}`
  }

  const getLegacyPlanOptionKey = (source, suggestion) =>
    `${source.name}::${getSuggestionText(suggestion)}`

  const planSuggestionText = useMemo(() => {
    const selectedValues = new Set(formattedSelectedPlanSuggestionsStrings)
    const grouped = {}

    selectedPlanSuggestion.forEach((source) => {
      source.suggestions.forEach((suggestion, index) => {
        const optionKey = getPlanOptionKey(source, suggestion, index)
        const legacyOptionKey = getLegacyPlanOptionKey(source, suggestion)

        if (!selectedValues.has(optionKey) && !selectedValues.has(legacyOptionKey)) return

        const suggestionText = getSuggestionText(suggestion)
        if (!suggestionText) return

        if (!grouped[source.name]) grouped[source.name] = []
        if (!grouped[source.name].includes(suggestionText)) grouped[source.name].push(suggestionText)
      })
    })

    return Object.entries(grouped)
      .flatMap(([parent, children]) => [`• ${parent}`, ...children.map((child) => `\t• ${child}`)])
      .join('\n')
  }, [formattedSelectedPlanSuggestionsStrings])

  const handleSubmitModal = () => {
    const finalAssessmentSuggestions = mergeAssessmentSuggestionText(
      getAssessmentBulletText(sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings).join('\n'),
      assessmentFinalValue,
      sugesstionsAssessmentsList
    )

    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment?.[diagnosisName],
          assessmentSuggestions: finalAssessmentSuggestions,
          formattedSelectedSuggestionIdString: selectedIds.join('\n'),
        },
      },
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans?.[diagnosisName],
          planSuggestion: planSuggestionText,
          formattedSelectedPlanSuggestionsStrings,
        },
      },
    }
    setAssessmentSuggestions(finalAssessmentSuggestions)
    setAssessmentFinalValue(finalAssessmentSuggestions)
    setAddedChangesToAssessment?.((prev) => !prev)
    setVisible(false)
  }

  const openAssessmentSuggestionsModal = () => {
    setActiveKey(1)
    setActiveKey2(2)
    setAssessmentFinalValue(
      mergeAssessmentSuggestionText(
        getAssessmentBulletText(sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings).join('\n'),
        assessmentSuggestions,
        sugesstionsAssessmentsList
      )
    )
    setVisible(true)
  }

  const labHtml =
  noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging;

// function to check if HTML has real content
const hasValidContent = (html) => {
  if (!html) return false;

  const temp = document.createElement('div');
  temp.innerHTML = html;

  return temp.textContent.trim().length > 0;
};
  return (
    <div className="">
      {showTreatmentAsAccordion ? (
        <div className="m2">
          <div className="d-flex align-items-center gap-1">
            <h7>
              <b>Assessment</b>
            </h7>
          </div>
          <hr />

          {labsImaging && (
            <div className="mb-4">
              <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                Labs & Imaging
              </label>

              <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                {labsImaging}
              </div>
            </div>
          )}

          {assessmentSuggestions && (
            <div className="mb-4">
              <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                Assessment Suggestions
              </label>

              <div className=" mt-1" dangerouslySetInnerHTML={{ __html: renderAssessmentSuggestionHtml(displayedAssessmentSuggestions) }} />
            </div>
          )}

          {freeType !== '' && (
            <div className="mb-4">
              <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                Free Type
              </label>

              <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                {freeType}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="m2">
          <div className="d-flex align-items-center gap-1">
            <h7>
              <b>Assessment</b>
            </h7>
          </div>
          <hr />
          {/* <div className="mb-4">
                <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>POA</label>
                <CFormTextarea
                    className="bg-secondary border rounded shadow-sm mt-2"
                    rows={3}
                    value={poa}
                    onChange={(e) => { handlePoaChange(e.target.value) }}
                />
            </div>

            <div className="mb-4">
                <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>Mobility Assessment</label>

                <div className="bg-secondary border rounded shadow-sm mt-2 p-2" style={{
                    minHeight: '43px'

                }}>
                    {mobilityData && questionFields.map((field) => {
                        const selected = mobilityData[field.key];
                        if (selected && selected.length > 0) {
                            const values = selected.map((item) => item.label).join(", ");
                            return (
                                <div key={field.key} className="" style={{ color: 'var(--ui-text-primary)', fontSize: '0.9rem', fontWeight: '400', fontFamily: 'Plus Jakarta Sans' }} >
                                    <strong >{field.label}:</strong> {values}
                                </div>
                            );
                        }
                        return null;
                    })}

                </div>
            </div>

            <div className="mb-4">
                <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>Morse Score</label>
                <CFormTextarea
                    className="bg-secondary border rounded shadow-sm mt-2"
                    rows={3}
                    disabled
                    value={total && morseScoreDate && `Morse Score: ${total}   recorded on Date: ${new Date(morseScoreDate).toLocaleDateString('en-US')}`}

                />
            </div> */}

          <div className="mb-4">
            <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
              Labs & Imaging
            </label>

            {/* {noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging && (
              <div className="my-2">
                <div
                  onClick={() => {
                    setTempHtmlContent(noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging)
                    setShowEditHtml(true)
                  }}
                  className="p-4"
                  style={{ background: '#f6f6f6ff', borderRadius: '10px', cursor: 'text' }}
                  dangerouslySetInnerHTML={{ __html: noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging }}
                ></div>
              </div>
            )} */}
              {hasValidContent(labHtml) && (
                <div className="my-2">
                  <div
                    className="p-2 patient-theme-old-data patient-theme-old-data--readonly patient-theme-old-data--final-note"
                    dangerouslySetInnerHTML={{ __html: labHtml }}
                  ></div>
                </div>
              )}
            <CFormTextarea className="bg-secondary border rounded shadow-sm mt-2" rows={3} value={labsImaging} onChange={(e) => handleLabsChanges(e.target.value)} />
          </div>

          <div className="mb-4">
            <div className="d-flex align-items-center gap-1">
              <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                Assessment Suggestions
              </label>
              {isAllotedToProvider && (
                <CFormLabel
                  className="patient-note-action d-flex mt-2 flex-column align-items-center justify-content-center shadow"
                  onClick={openAssessmentSuggestionsModal}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '20px',
                    background: 'var(--ui-color-primary, #2b7cd3)',
                    cursor: 'pointer',
                  }}
                >
                  <Plus className="patient-note-action-icon" strokeWidth={2} size={15} />
                </CFormLabel>
              )}
            </div>
            <div
              className="bg-secondary border rounded shadow-sm mt-2"
              onClick={openAssessmentSuggestionsModal}
              onFocus={openAssessmentSuggestionsModal}
              tabIndex={0}
              style={{
                minHeight: '50px',
                padding: '10px',
                cursor: 'pointer',
                wordBreak: 'break-word',
              }}
            >
              {displayedAssessmentSuggestions ? (
                <div style={{ margin: 0 }} dangerouslySetInnerHTML={{ __html: renderAssessmentSuggestionHtml(displayedAssessmentSuggestions) }} />
              ) : (
                <span style={{ color: '#989898' }}>No suggestions</span>
              )}
            </div>
          </div>

          <div className="mb-2">
            <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
              Free Type
            </label>
            <Graytextarea rows={5} height="20px" onClick={() => setVisibleModalTempFreeType((p) => !p)} value={freeType} />
          </div>
        </div>
      )}
      <CModal className="modal-assessment assessment-suggestion-modal" visible={visible} onClose={() => setVisible(false)} aria-labelledby="ToggleBetweenModalsExample1">
        <CModalBody>
          <CNav className="d-flex align-items-center gap-2 assessment-suggestion-modal__tabs" variant="pills">
            <CNavItem className="">
              <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)} style={{ cursor: 'pointer' }}>
                Suggestion
              </CNavLink>
            </CNavItem>
            <CNavItem className="">
              <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)} style={{ cursor: 'pointer' }}>
                Assessment
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2" visible={activeKey === 1}>
              <CContainer className="p-0 border m-0 assessment-suggestion-modal__split">
                <CRow>
                  <CCol
                    style={{
                      width: '50%',
                      overflowY: 'scroll',
                      height: '80vh',
                      borderRight: '1px solid #e2e2e2',
                    }}
                    className="w-50 p-4 assessment-suggestion-modal__left-pane"
                  >
                    <div>{sugesstionsAssessmentsList?.length > 0 ? renderAccordions() : <div>No Suggestions Available</div>}</div>
                  </CCol>

                  <CCol
                    style={{
                      width: '50%',
                      overflowY: 'scroll',
                      height: '80vh',
                    }}
                    className="w-50 assessment-suggestion-modal__right-pane"
                  >
                    <p className="text-center p-2 fw-bold assessment-suggestion-modal__section-title">Add to plan</p>
                    <div className="d-flex align-items-center gap-2">
                      <CButton
                        onClick={() => {
                          setActiveKey2(1)
                          setOrderModalVisible(true)
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        Orders
                      </CButton>
                      <CButton active={activeKey2 === 2} onClick={() => setActiveKey2(2)} style={{ cursor: 'pointer' }}>
                        Statements
                      </CButton>
                    </div>

                    <CTabContent>
                      <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2" visible={activeKey2 === 2}>
                        <div>
                          {selectedPlanSuggestion.map((item) => {
                            return (
                              <CAccordion flush key={item.key} className="assessment-suggestion-modal__accordion assessment-suggestion-modal__plan-accordion">
                                <CAccordionItem itemKey={1}>
                                  <CAccordionHeader className="" style={{ fontSize: '10px' }}>
                                    <div className="d-flex align-items-center gap-2">
                                      {item?.description && item?.description !== '' && (
                                        <CTooltip content={item?.description ? item?.description : 'Add the tooltip'}>
                                          <Info strokeWidth={1} size={16} />
                                        </CTooltip>
                                      )}
                                      {item.name}
                                    </div>
                                  </CAccordionHeader>
                                  <CAccordionBody>
                                    <div>
                                      {item.suggestions.length > 0 &&
                                        item.suggestions &&
                                        item.suggestions.map((listItem, optionIndex) => {
                                          const suggestionText = getSuggestionText(listItem)
                                          if (!suggestionText) return null
                                          const uniqueValue = getPlanOptionKey(item, listItem, optionIndex)
                                          const legacyValue = getLegacyPlanOptionKey(item, listItem)
                                          const descriptionKey = `plan-${item.key}-${optionIndex}`

                                          return (
                                            <div key={uniqueValue}>
                                              <div className="d-flex align-items-center gap-2">
                                                <CFormCheck
                                                  onChange={() => {
                                                    setFormattedSelectedPlanSuggestionsStrings((prevFormatted) => {
                                                      const isChecked = prevFormatted.includes(uniqueValue)
                                                      return isChecked
                                                        ? prevFormatted.filter((s) => s !== uniqueValue && s !== legacyValue)
                                                        : [...prevFormatted.filter((s) => s !== legacyValue), uniqueValue]
                                                    })
                                                  }}
                                                  id={uniqueValue}
                                                  checked={formattedSelectedPlanSuggestionsStrings.includes(uniqueValue)}
                                                  label={suggestionText}
                                                />
                                                {listItem?.description && (
                                                  <span
                                                    className="d-inline-flex align-items-center"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => setShowItemsDescriptions((prev) => (prev.includes(descriptionKey) ? prev.filter((key) => key !== descriptionKey) : [...prev, descriptionKey]))}
                                                  >
                                                    <Info strokeWidth={1} size={16} />
                                                  </span>
                                                )}
                                              </div>
                                              {listItem?.description && showItemsDescriptions.includes(descriptionKey) && <div style={{ color: 'orange', whiteSpace: 'pre-line', fontSize: '12px', padding: '8px 10px' }}>{listItem.description}</div>}
                                            </div>
                                          )
                                        })}
                                    </div>
                                  </CAccordionBody>
                                </CAccordionItem>
                              </CAccordion>
                            )
                          })}
                        </div>
                      </CTabPane>
                    </CTabContent>
                  </CCol>
                </CRow>
              </CContainer>
            </CTabPane>
            <CTabPane role="tabpanel" aria-labelledby="profile-tab" className="mt-2" visible={activeKey === 2}>
              <BulletTextArea assessmentEditor onChange={(e) => setAssessmentFinalValue(e.target.value)} value={assessmentFinalValue} />
            </CTabPane>
          </CTabContent>
        </CModalBody>
        <CModalFooter>
          <CButton
            onClick={() => {
              setVisible(false)
              setShowItemsDescriptions([])
            }}
            color="secondary"
          >
            Close
          </CButton>
          <CButton
            className="assessment-suggestion-modal__clear-btn"
            onClick={() => {
              setSelectedPlanSuggestion([])
              setSelectedAssessmentSuggestionString([])
              setSelectedId([])
              setSelectedOrder([])
              setAssessmentFinalValue('')
              setFormattedSelectedPlanSuggestionsStrings([])
              setAssessmentSuggestions('')
              noteStructureRef.current = {
                ...noteStructureRef.current,
                assessment: {
                  ...noteStructureRef.current.assessment,
                  [diagnosisName]: {
                    ...noteStructureRef.current.assessment?.[diagnosisName],
                    assessmentSuggestions: '',
                    formattedSelectedSuggestionIdString: '',
                  },
                },
                plans: {
                  ...noteStructureRef.current.plans,
                  [diagnosisName]: {
                    ...noteStructureRef.current.plans?.[diagnosisName],
                    planSuggestion: '',
                    formattedSelectedPlanSuggestionsStrings: [],
                  },
                },
              }
            }}
            color="secondary"
          >
            Clear All
          </CButton>
          <CButton color="primary" className="ui-action-btn ui-action-btn--primary" onClick={handleSubmitModal}>
            Save
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal className="assessment-order-modal" size="lg" backdrop="static" visible={orderModalVisible} onClose={() => setOrderModalVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        <FetchOrderForAssessment
          patientID={patientID}
          noteID={noteID}
          diagnosisName={diagnosisName}
          toggleModal={() => {
            setOrderModalVisible((p) => !p)
            setActiveKey2(1)
          }}
          fetchOrdersAgain={() => setAddedChangesToAssessment?.((prev) => !prev)}
          selectedOrder={selectedOrder}
        />
      </CModal>

      {/* freetype modal */}
      <CModal backdrop="static" visible={visibleModalTempFreeType} onClose={() => setVisibleModalTempFreeType(false)} aria-labelledby="LiveDemoExampleLabel">
        <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">Add Assessment Freetype</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <BulletTextArea placeholder="Enter freetype" value={tempFreeType} rows={4} onChange={(e) => setTempFreeType(e.target.value)} />
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setVisibleModalTempFreeType(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleSaveFreetype} >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Morse Score Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  assessments: {
                    ...noteStructureRef.current?.freeTypesEverything?.assessments,
                    [diagnosisName]: {
                      ...noteStructureRef.current?.freeTypesEverything?.assessments?.[diagnosisName],
                      LabImaging: tempHtmlContent,
                    },
                  },
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
            }}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default FallsAssessment
